import id from 'element-ui/lib/locale/lang/id';

// 印尼语(印度尼西亚)
export default {
  ...id,
  layout: {
    title: 'Masuk dengan ID Uniportal',
    tip: 'Nomor ponsel yang tidak terdaftar akan didaftarkan secara otomatis setelah berhasil masuk',
    line: 'Opsi Login Lainnya',
  },
  button: {
    submit: 'Login/Daftar',
    getCode: 'Dapatkan kode',
    emailRegister: 'Mendaftar dengan Email',
    w3Login: 'Log Masuk Akun W3',
    employeeLogin: 'Login Karyawan',
    passwordLogin: 'Password Login',
    reSend: 'Kirim ulang',
    problem: 'Bantuan Online',
    privacyPolicy: 'Kebijakan Pribadi',
  },
  placeholder: {
    phoneNumber: 'Nomor ponsel',
    verificationCode: 'Kod weryfikacyjny SMS',
  },
  dialog: {
    imgCode: 'Masukkan karakter pada gambar.',
    userAgreements: {
      header: 'Perjanjian Pengguna dan Pernyataan Privasi',
      text1: 'Baca serta setujui {privacy} dan {agreement}.',
      text2:
        'Informasi pribadi akan ditransfer ke anak perusahaan Huawei di luar negeri untuk diproses saat mengakses aplikasi Huawei di luar negeri. Untuk rincian, lihat {privacy}',
    },
    crossBorder: {
      header: 'Kiat otorisasi',
      text: 'Layanan lokal yang Anda gunakan tidak berada di wilayah yang sama dengan tempat akun Anda terdaftar. Akses lintas batas ke informasi akun memerlukan otorisasi Anda.',
    },
    multiAccounts: 'Pilih akun.',
    agreeButton: 'Setuju dan Lanjutkan',
    disagreeButton: 'Tidak setuju',
    confirmButton: 'konfirmasi',
    cancelButton: 'Batal',
    knowMe: 'Aku mengerti',
  },
  toast: {
    hasSend: 'Kode verifikasi terkirim.',
    wait: 'Tunggu sebentar',
  },
  tooltip: {
    Huawei: 'ID Huawei',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Kode CAPTCHA tidak boleh kosong.',
    'IDC-03-0002': 'Kode CAPTCHA telah kedaluwarsa.',
    'IDC-00-0004': 'Kode CAPTCHA salah.',

    // 表单输入为空
    'IDC-01-00024': 'Kode negara diperlukan untuk memverifikasi nomor ponsel Anda.',
    phoneNumberEmpty: 'Masukkan nomor ponsel.',
    'IDC-03-00033': 'Masukkan kode verifikasi SMS.',

    // 表单数据错误
    'IDC-02-00227': 'Nomor ponsel yang dimasukkan tidak cocok dengan negara yang dipilih',
    'IDC-02-00226': 'Kode negara dilarang',
    'IDC-02-00029': 'Captcha salah atau kedaluwarsa',
    'IDC-02-0013': 'Login melalui SMS gagal, kode verifikasi salah',
    'IDC-02-0020': 'Verifikasi gagal. Kode verifikasi salah.',
    'IDC-02-00028': 'Nomor ponsel harus berupa angka dengan panjang 6 hingga 30',
    'IDC-02-00012': 'Nomor ponsel salah',

    // 错误操作锁定
    accountLock: 'Nomor ponsel atau kode verifikasi salah. {number} percobaan tersisa.',
    accountLocked: 'Terlalu banyak percobaan yang gagal. Coba lagi setelah {number} detik.',
    operationRisk: 'Operasi saat ini memiliki risiko keamanan. Silakan coba lagi dalam {number} detik.',

    // 频繁操作
    'IDC-02-00038': 'Silakan coba lagi setelah 60 dtk.',
    'IDC-02-00064':
      'Anda telah mengirim kode verifikasi SMS terlalu sering. Silakan coba lagi 24 jam kemudian.',
    'IDC-02-00211': 'Operasi saat ini memiliki risiko keamanan. Silakan coba lagi nanti.',
    'IDC-02-00212':
      'Jumlah kode verifikasi SMS yang dikirim oleh nomor ponsel Anda terlalu sering. Gantilah nomor ponsel kalian atau coba lagi 24 jam kemudian.',
    'IDC-02-00213':
      'Anda telah mengirim kode verifikasi SMS terlalu sering. Silakan coba lagi 24 jam kemudian.',
    'IDC-02-00215':
      'Jumlah kode verifikasi SMS yang dikirim oleh nomor ponsel Anda terlalu sering. Silakan coba mengubah nomor ponsel atau memilih metode verifikasi lain, atau coba lagi 24 jam kemudian.',
    'IDC-02-00228':
      'Anda terlalu sering mengirim kode verifikasi SMS. Silakan coba lagi dalam satu jam!',
    'IDC-02-00092': 'Operasi saat ini terlalu sering terjadi. Silakan coba lagi 24 jam kemudian.',

    // 请求异常
    'IDC-10-00400': 'Permintaan pelanggan tidak normal',
    'IDC-10-00500': 'Kesalahan internal sistem ',
    'IDC-02-00264': 'Permintaan tidak sah untuk akses dilarang',
    'IDC-02-00063': 'Parameter tidak valid',
    'IDC-03-0007':
      'Operasi saat ini memiliki risiko keamanan dan tidak dapat didaftarkan untuk saat ini.', // 机翻
    'IDC-03-00057': 'Operasi saat ini memiliki risiko keamanan.',

    // 页面过期
    'IDC-00-00017': 'Halaman ini sudah kedaluwarsa.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Kembali',
  closeButton: 'Tutup',

  // 滑块验证相关：
  resourceReqFailed: 'Permintaan sumber daya gagal. Segar kembali halamannya dan coba lagi.',
  verifyFailedAndPlsRetry: 'Verifikasi gagal, coba lagi',
  serviceErrAndPlsRetry: 'pengecualian layanan Silakan coba lagi.',
  learnMore: 'Pelajari lebih lanjut',
  cookieBannerText: 'Situs web ini menggunakan fitur cookie untuk memberi Anda pengalaman pengguna terbaik.',
};
